import { render, staticRenderFns } from "./index-exchange-list.vue?vue&type=template&id=658c7e93&"
import script from "./index-exchange-list.vue?vue&type=script&lang=js&"
export * from "./index-exchange-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports